import React, { useCallback } from 'react';
import { formatter } from '@repo/shared';
import { FileSpreadsheet, X } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface FileUploadProps {
  file: File;
  onRemove: (file: File) => void;
}

const FileUpload = ({ file, onRemove }: FileUploadProps) => {
  const handleRemove = useCallback(() => {
    onRemove(file);
  }, [onRemove, file]);
  return (
    <div className='bg-muted relative rounded-lg p-3'>
      <div className='absolute right-1 top-1'>
        <Button
          type='button'
          variant='ghost'
          size='sm'
          onClick={handleRemove}>
          <Button.Icon icon>
            <X />
          </Button.Icon>
        </Button>
      </div>
      <div className='flex items-center space-x-2.5'>
        <span className='bg-background ring-input flex h-10 w-10 shrink-0 items-center justify-center rounded-sm shadow-sm ring-1 ring-inset'>
          <FileSpreadsheet
            className='text-foreground size-5'
            aria-hidden={true}
          />
        </span>
        <div className='w-full'>
          <p className='text-foreground text-xs font-medium'>{file.name}</p>
          <p className='text-muted-foreground mt-0.5 flex justify-between text-xs'>
            <span>{formatter.bytes.format(file.size)}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
